import { type SelectOption } from '../inputs/SelectInput.tsx';

/**
 * Appiattisce una lista di `SelectOption` ritornando tutte le opzioni
 * "foglia" (quelle con un `value`), attraversando ricorsivamente i gruppi
 * (opzioni raggruppate tramite divider, con figli in `option.options`).
 *
 * Utile per cercare l'opzione selezionata per valore indipendentemente dal
 * fatto che le opzioni siano piatte o raggruppate.
 */
export function flattenSelectOptions(
  options: SelectOption[] | null | undefined,
): SelectOption[] {
  const result: SelectOption[] = [];

  options?.forEach(option => {
    if (option.options && option.options.length > 0) {
      result.push(...flattenSelectOptions(option.options));
    }
    if (option.value != null) {
      result.push(option);
    }
  });

  return result;
}
